import React, { useMemo } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useMetadata } from '../../../../contexts/MetadataContext';
import DownloadButton from './DownloadButton';

const HelpPanel: React.FC = () => {
  const { lookup } = useMetadata();

  const roomFeatures = useMemo(() => lookup('Room_Features'), [lookup]);
  const roomTypes = useMemo(() => lookup('Sub_Room_Types'), [lookup]);

  const templateData: string[][] = [
    ['RoomType 1', 'RoomFeature 1', 'RoomFeature 2', 'RoomFeature 3', 'Etc.'],
    [
      'RoomType 2.RoomType 3.RoomType 4',
      'RoomFeature 4',
      'RoomFeature 5',
      'RoomFeature 6',
      'Etc.',
    ],
    ['RoomType 5.RoomType 6', 'RoomFeature 1', 'RoomFeature 3'],
    ['RoomType 7', 'RoomFeature 7'],
  ];
  return (
    <Box sx={{ padding: 3 }}>
      <Typography sx={{ fontWeight: 'bold' }}>Description</Typography>
      <Typography>
        This feature allows you to hide certain room features from certain room
        types. For example, you might not want &quot;Basement&quot; to have
        &quot;Attic - Finished&quot; as a feature.
      </Typography>
      <Box sx={{ my: 2 }} key="rooms-list">
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`rooms-list-content`}
            id={`rooms-list-header`}
          >
            <Typography component="span">Available Room Types</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {roomTypes?.map((roomType) => (
              <ListItem key={roomType.LookupKey}>
                {roomType.LookupValue}
              </ListItem>
            ))}
          </AccordionDetails>
        </Accordion>
      </Box>
      <Box sx={{ my: 2 }} key="room-features-list">
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`room-features-list-content`}
            id={`room-features-list-header`}
          >
            <Typography component="span">Available Room Features</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {roomFeatures?.map((feature) => (
                <ListItem key={feature.LookupKey}>
                  {feature.LookupValue}
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
        <Typography sx={{ fontWeight: 'bold', mt: 4 }}>CSV Template</Typography>
        <Typography>
          Here is an example format for the csv upload. If you want the same row
          of lookups to be filtered from multiple resources, separate them with
          periods like this - Attic.Basement.Foyer
        </Typography>
        <DownloadButton data={templateData} />
      </Box>
    </Box>
  );
};

export default React.memo(HelpPanel);
